import { render, staticRenderFns } from "./nursePresAddAj.vue?vue&type=template&id=e34e63a0&scoped=true"
import script from "./nursePresAddAj.vue?vue&type=script&lang=ts"
export * from "./nursePresAddAj.vue?vue&type=script&lang=ts"
import style0 from "./nursePresAddAj.vue?vue&type=style&index=0&id=e34e63a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34e63a0",
  null
  
)

export default component.exports